/** @jsx jsx */

import { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';

const FeedbackFailed = ({ children, ...props }) => {
  const [img, txt, btn] = children;

  return (
    <div
      css={css({
        width: '100%',
      })}
    >
      {txt}
    </div>
  );
};

export default FeedbackFailed;
